export default __webpack_public_path__ + "completion-email-example.1b85500b.png";